import { Tooltip } from '@material-ui/core';
import { EPartnerCode } from 'interfaces/IProduct';
import React from 'react';

import type IProduct from 'interfaces/IProduct';

function BlockedFieldTooltipProps(props: { product: IProduct; enabled: boolean; children: React.ReactElement; title?: string }) {
  const { enabled, product, children, title } = props;

  if (!enabled) return children;

  const isAlumy = product.cnt_partner_cod === EPartnerCode.ALUMY;
  const isBlinket = product.cnt_partner_cod === EPartnerCode.BLINKET;
  const app = isBlinket ? 'Blinket' : isAlumy ? 'Alumy' : false;

  if (!app) return children;

  return (
    <Tooltip
      {...{
        disableFocusListener: !enabled,
        disableHoverListener: !enabled,
        disableTouchListener: !enabled,
        title: title ?? `Esta informação só pode ser alterada na configuração do produto ${app}`,
      }}
    >
      {children}
    </Tooltip>
  );
}
export default BlockedFieldTooltipProps;
